import { baseApi } from "@/config/http-common";

class JobDataService {
  getAll(page: any, params: any): Promise<any> {
    return baseApi.get("/users/jobs/list", {
      params: { page: page, name: params.name, status: params.status },
    });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/users/jobs/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/users/jobs/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/users/jobs/update/${id}`, data);
  }

  delete(id: string): Promise<any> {
    return baseApi.delete(`/users/jobs/delete/${id}`);
  }
}

export default new JobDataService();
